/**
 * Export API client — download tasks as CSV.
 */
import { apiClient } from './index';

/** Downloads project tasks as a CSV file. Triggers browser file download. */
export async function exportProjectCSV(projectId: string, projectName: string): Promise<void> {
  const response = await apiClient.get(`/projects/${projectId}/export`, {
    responseType: 'blob',
  });
  const blob = new Blob([response.data as BlobPart], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${projectName.replace(/\s+/g, '_')}_tasks.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

